import { defineMessages } from 'react-intl';

export default defineMessages({
    qualificationTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.Qualification.Title",
        defaultMessage: "Eligibility Requirements Apply to all Locations and Structures"
    },
    TWIACommercialQualificationPropertyTitle: {
        id: 'quoteandbind.wizard.commercial.TWIA.Qualification.Property',
        defaultMessage: 'TWIA Property Eligibility',
    },
    TWIACommercialQualificationElegibilityErrorTitle: {
        id: 'quoteandbind.wizard.commercial.TWIA.Qualification.Error.Elegibility',
        defaultMessage: 'Eligibility Error',
    },
})